<template>
    <div>
        <transition name="fade">
            <div v-if="loaded && !cart.products.length" class="my-4">
                {{ t.cart.empty_cart }}
            </div>
        </transition>
        <div v-if="loaded && cart.products.length" class="row">
            <div class="col-12 col-lg-9">
                <transition-group name="fade">
                    <div class="row pb-4" v-for="product in cart.products" :key="product.id">
                        <div class="col-6 col-md-3 mb-3 mb-md-0 pe-0">
                            <a :href="product.url">
                                <img :src="product.thumbnail" alt="" class="img-fluid">
                            </a>
                        </div>
                        <div class="col-6 col-md-4 align-self-center">
                            <div>
                                <div class="h4 mb-0">
                                    <a :href="product.url">
                                        {{product.name}}
                                    </a>
                                </div>
                                <div class="d-none d-lg-block small text-muted mb-1" v-html="truncateText(stripTags(product.description ? product.description : product.long_description), 80)"></div>
                                <div class="mb-2" v-if="product.product_variation_attributes">
                                    <div v-for="(prod_var_attr, index) in product.product_variation_attributes" :key="index"><b>{{prod_var_attr.attribute.name}}</b>: {{prod_var_attr.value.name}}</div>
                                </div>
                                <div class="text-muted fw-bold">{{ amountWithCurrency(product.price) }}</div>
                                <div v-if="config.modules.gift" class="mt-2">
                                    <label :for="'is_gift_'+product.id" v-if="settings.gift_price">
                                        <input :disabled="loading" type="checkbox" :id="'is_gift_'+product.id" v-model="product.is_gift" @change="updateProduct(product)"> {{ t.cart.is_gift }} <span class="text-muted">(+{{ amountWithCurrency(settings.gift_price) }} {{t.cart.per_item}})</span>
                                    </label>
                                    <transition name="fade">
                                        <div class="mt-2" v-if="product.is_gift">
                                            <textarea v-model="product.gift_card" class="form-control" :placeholder="t.gift_card"
                                            :maxlength="settings.gift_card_max_char"
                                            @change="updateProduct(product)"
                                            ></textarea>
                                            <div class="small text-muted">*{{ t.cart.gift_card_max_characters}}: {{settings.gift_card_max_char}}</div>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center d-none d-md-block">
                            <div class="row">
                                <div class="col-md-6 align-self-center">
                                    <div class="input-group">
                                        <span class="input-group-prepend"><button @click="product.qty--; updateProduct(product)" :disabled="loading" type="button" class="btn btn-light">-</button></span>
                                        <input type="text"  @focus="$event.target.select()" class="form-control text-center border-0" :disabled="loading" v-model.number="product.qty" @change="updateProduct(product)">
                                        <span class="input-group-prepend"><button @click="product.qty++; updateProduct(product)" :disabled="loading" type="button" class="btn btn-light">+</button></span>
                                    </div>
                                </div>
                                <div class="col-md align-self-center text-center fw-bold lead">{{ amountWithCurrency(product.total) }}</div>
                            </div>
                        </div>
                        <div class="col-md-1 align-self-center text-muted d-none d-md-block"><i class="fas fa-times fa-xl cursor-pointer" @click="deleteProduct(product)"></i></div>
                        <!-- Qty & Price Mobile -->
                        <div class="col-md-4 align-self-center mt-2 mt-md-0 d-md-none">
                            <div class="row">
                                <div class="col-6 align-self-center">
                                    <div class="input-group">
                                        <span class="input-group-prepend"><button @click="product.qty--; updateProduct(product)" :disabled="loading" type="button" class="btn btn-light">-</button></span>
                                        <input type="text"  @focus="$event.target.select()" class="form-control text-center border-0" :disabled="loading" v-model.number="product.qty" @change="updateProduct(product)">
                                        <span class="input-group-prepend"><button @click="product.qty++; updateProduct(product)" :disabled="loading" type="button" class="btn btn-light">+</button></span>
                                    </div>
                                </div>
                                <div class="col align-self-center">
                                    <span class="fw-bold me-3 lead">{{ amountWithCurrency(product.total) }}</span>
                                    <span class="text-muted"><i class="fas fa-times cursor-pointer" @click="deleteProduct(product)"></i></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition-group>
                <cart-vouchers-component class="mt-5"></cart-vouchers-component>
            </div>
            <div class="col">
                <div v-if="config.modules.vouchers">
                    <label for="voucher">{{ t.vouchers.enter_voucher }}</label>
                    <input
                        type="text"
                        id="voucher"
                        class="form-control mb-2"
                        v-model="voucher"
                        @keypress.enter="sendVoucher()"
                    />
                    <button
                        class="btn btn-light w-100 mb-3"
                        @click="sendVoucher()"
                        autocomplete="off"
                    >
                        {{ t.vouchers.apply_voucher }}
                    </button>
                </div>
                <cart-summary-component></cart-summary-component>
                <transition name="fade">
                    <a :href="url('checkout')" class="btn btn-primary btn-md w-100 mt-3" v-if="loaded && cart.products.length">
                        {{ t.cart.checkout }}
                    </a>
                </transition>
            </div>
        </div>
        <div v-if="loaded && bundles && bundles.length" class="mt-5">
            <h4 class="mt-5">{{t.bundles.bundle_offers}}</h4>
            <div class="row">
                <div v-for="bundle in bundles" class="col-12 col-md-6">
                    <bundle-block-component :data-bundle="bundle"></bundle-block-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../CartStore'
    export default {
        store: store,
        data() {
            return {
                t: t,
                config: config,
                settings: settings,
                bundles: config.modules.bundles ? bundles : null,
                voucher: ''
            }
        },
        mounted() {
            this.$store.dispatch('getCart')
        },
        computed: {
            ...Vuex.mapGetters(['loaded', 'loading', 'cart']),
        },
        methods: {
            sendVoucher() {
                if (this.voucher) {
                    this.applyVoucher(this.voucher)
                    this.voucher = ''
                }
            },
            ...Vuex.mapActions(['deleteProduct', 'updateProduct', 'applyVoucher', 'addBundle']),
        }
    }
</script>
